import React, { useState } from 'react';
import './MenuPage.css';
import Hero from '../components/Hero';
import placeholderFoodImage from '../assets/food-old/IMG_0437-750x465.jpg';
import placeholderImage from '../assets/placeholder.webp';
import avgolemonoImage from '../assets/food/IMG_6171-750x465.jpg';
import meatballsImage from '../assets/food/IMG_6190-750x465.jpg';
import zucchiniCakesImage from '../assets/food/IMG_6184-750x465.jpg';

// Food images imports
import loadedPotatoesImage from '../assets/food/loadedPotatoes.avif';
import avocadoEggRollsImage from '../assets/food/avocadoEggRolls.avif';
import streetCornRibsImage from '../assets/food/streetCornRibs.png';
import bcbEggrollsImage from '../assets/food/bcbEggrolls.png';
import macNCheeseBallsImage from '../assets/food/macNCheeseBalls.avif';
import friedZucchiniImage from '../assets/food/friedZucchini.avif';
import chickenWingsImage from '../assets/food/chickenWings.avif';
import bakedPotatoImage from '../assets/food/bakedPotato.avif';
import nyStreakSteakImage from '../assets/food/nyStripSteak.avif';
import macNCheeseImage from '../assets/food/macNCheeseSide.avif';
import onionRingsImage from '../assets/food/onionRings.avif';
import smashBurgerImage from '../assets/food/smashBurger.avif';
import crispyChxSandwichImage from '../assets/food/crispyChxSandwich.avif';
import gourmetBurgerImage from '../assets/food/gourmentBurger.avif';
import theItalianImage from '../assets/food/theItalian.png';
import crispyBuffaloChickenWrapImage from '../assets/food/crispyBuffaloChickenWrap.avif';
import bakedPastaImage from '../assets/food/bakedPasta.avif';
import nachoFriesImage from '../assets/food/nachoFries.png';
import friedRiceImage from '../assets/food/friedRice.avif';

const FoodMenu: React.FC = () => {
  const [modalImage, setModalImage] = useState<string | null>(null);
  const [modalAlt, setModalAlt] = useState<string>('');
  const [activeTab, setActiveTab] = useState<string>('appetizers');

  const openModal = (imageSrc: string, altText: string) => {
    setModalImage(imageSrc);
    setModalAlt(altText);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAlt('');
  };

  const menuData = {
    "appetizers": [
      {
        name: "LOADED POTATOES",
        price: "$11.95",
        description: "Crispy potato wedges piled high with melted cheddar, smoky bacon bits, green onions, and a dollop of sour cream. Served hot and hearty—perfect for sharing",
        image: loadedPotatoesImage
      },
      {
        name: "AVOCADO EGGROLLS",
        price: "$11.95",
        description: "Creamy avocado, sun-dried tomatoes, red onion, and cilantro all inside a crispy egg roll wrapper.",
        image: avocadoEggRollsImage
      },
      {
        name: "STREET CORN RIBS",
        price: "$11.95",
        description: "Fresh corn on the cob, quartered into rib-style strips, grilled until tender and lightly charred, then brushed with a sweet and smoky house glaze. Finished with a sprinkle of chili-lime seasoning for a bold, finger-licking twist on classic corn.",
        image: streetCornRibsImage
      },
      {
        name: "BCB EGGROLLS",
        price: "$11.95",
        description: "Crispy, golden shells filled with a savory mix of seasoned vegetables and tender pork (or chicken), hand-rolled and fried to perfection. Served with sweet chili sauce for dipping and just the right amount of zing.",
        image: bcbEggrollsImage
      },
      {
        name: "MAC & CHEESE BALLS",
        price: "$11.95",
        description: "Golden, crispy bites of comfort—our Mac & Cheese Balls are packed with creamy, three-cheese macaroni, breaded to perfection, and fried until irresistibly crunchy. Served with a side of house-made spicy aioli for the perfect kick.",
        image: macNCheeseBallsImage
      },
      {
        name: "FRIED ZUCCHINI",
        price: "$11.95",
        description: "Tender zucchini slices, lightly breaded and fried to a golden crunch. Served with your choice of ranch or zesty marinara for dipping—simple, crispy, and totally addictive.",
        image: friedZucchiniImage
      },
      {
        name: "MOZZARELLA STICKS",
        price: "$11.95",
        description: "Melted mozzarella wrapped in a crisp, golden breadcrumb coating—hot, stretchy, and satisfying in every bite. Served with a side of rich marinara sauce for the perfect cheesy dunk.",
        image: placeholderImage
      },
      {
        name: "JALAPENO POPPERS",
        price: "$11.95",
        description: "Fiery jalapeños stuffed with smooth cream cheese, lightly breaded and fried to a golden crisp. Each bite delivers the perfect balance of heat and creamy indulgence. Served with ranch or chipotle aioli for dipping.",
        image: placeholderImage
      },
      {
        name: "MAC & CHEESE WEDGES",
        price: "$11.95",
        description: "Creamy macaroni and cheese, blended with a savory cheddar mix, coated in a crispy golden crust and fried to perfection. These bite-sized wedges are crunchy on the outside, melty on the inside, and served with a side of tangy ranch or zesty marinara.",
        image: placeholderImage
      },
      {
        name: "VEGAN CHX TENDERS",
        price: "$11.95",
        description: "Plant-based, crispy, and packed with flavor—our vegan tenders are the perfect meatless option without sacrificing the crunch or the sauce. Toss them in your choice of bold flavors: Buffalo, BBQ, Mango Habanero, Lemon Pepper, Sweet Chili, and Honey Bourbon",
        image: placeholderImage
      },
      {
        name: "GARLIC PARM FRIES",
        price: "$11.95",
        description: "Crispy golden fries tossed in roasted garlic, melted butter, and a generous sprinkle of grated Parmesan. Finished with a touch of parsley for a bold, savory bite that's impossible to resist.",
        image: placeholderImage
      },
      {
        name: "CHICKEN TENDERS",
        price: "$11.95",
        description: "Crispy, golden, and juicy—our hand-breaded chicken tenders are cooked to perfection and served with your choice of dipping sauce. Whether you like it classic or bold, these tenders hit the spot every time.",
        image: placeholderImage
      },
      {
        name: "CHICKEN WINGS",
        price: "$11.95",
        description: "Juicy, crispy wings, tossed in your choice of bold, crave-worthy sauces: Buffalo, BBQ, Mango Habanero, Lemon Pepper, Sweet Chili, and Honey Bourbon",
        image: chickenWingsImage
      }
    ],
    "sides": [
      {
        name: "BAKED POTATO",
        price: "",
        description: "Fluffy inside, crispy outside, and loaded with cheddar, bacon, green onions, and sour cream. Add chili or swap toppings to make it your own!",
        image: bakedPotatoImage
      },
      {
        name: "NY STEAK (SIDE)",
        price: "",
        description: "A tender 6 oz. cut, grilled to perfection with our house seasoning. Add garlic butter or sautéed onions for an extra kick.",
        image: nyStreakSteakImage
      },
      {
        name: "CRISPY GRILLED CHICKEN (SIDE)",
        price: "$8.00",
        description: "Tender, juicy chicken breast grilled to perfection — a lean, flavorful addition to any dish.",
        image: placeholderImage
      },
      {
        name: "WEDGES",
        price: "",
        description: "",
        image: placeholderImage
      },
      {
        name: "MAC & CHEESE",
        price: "$8.00",
        description: "Rich, creamy, and loaded with melted cheese — the ultimate comfort side done right.",
        image: macNCheeseImage
      },
      {
        name: "ONION RINGS",
        price: "$8.00",
        description: "Golden, crunchy, and served with a tangy dipping sauce. Perfect for sharing... or not!",
        image: onionRingsImage
      },
      {
        name: "PRAWNS",
        price: "$10.00",
        description: "Perfectly breaded and fried to golden perfection, served with a zesty dipping sauce. A bite of seaside flavor in every crunch!",
        image: placeholderImage
      },
      {
        name: "MEATLESS CHICKEN",
        price: "",
        description: "Savory and satisfying — our grilled plant-based chicken is packed with flavor and perfectly seasoned. A great meat-free add-on to any meal.",
        image: placeholderImage
      }
    ],
    "sandwiches": [
      {
        name: "SMASH BURGER",
        price: "$15.95",
        description: "Two juicy beef patties stacked with American cheese, crispy bacon, grilled onions, and spicy aioli — all on a toasted brioche bun.",
        image: smashBurgerImage
      },
      {
        name: "CRISPY CHX SANDWICH",
        price: "$15.95",
        description: "Golden-crisp chicken with melted gouda cheese, bacon, spicy aioli, and a hint of honey in a brioche bun.",
        image: crispyChxSandwichImage
      },
      {
        name: "STEAK SANDWICH",
        price: "$15.95",
        description: "Juicy NY steak, gooey gouda cheese, and sweet grilled onions in a Hoagie roll.",
        image: placeholderImage
      },
      {
        name: "PHILLY CHEESESTEAK",
        price: "$15.95",
        description: "Savory slices of NY steak piled with grilled bell peppers, mushrooms, and onions, topped with melted cheese.",
        image: placeholderImage
      },
      {
        name: "GOURMET BURGER",
        price: "$15.95",
        description: "Half-pound Angus beef patty topped with melted American cheese, crispy bacon, fresh lettuce, tomato, onion, and a kick of house-made spicy aioli — all on a toasted artisan bun.",
        image: gourmetBurgerImage
      },
      {
        name: "CHX PARM SANDWICH",
        price: "$15.95",
        description: "Crispy chicken cutlet smothered in marinara, topped with parmesan and melted mozzarella on a warm ciabatta roll.",
        image: placeholderImage
      },
      {
        name: "PATTY MELT",
        price: "$15.95",
        description: "A half-pound beef patty stuffed with smoked Gouda, topped with more melted Gouda and grilled onions on toasted sourdough.",
        image: placeholderImage
      },
      {
        name: "GRILLED CHEESE & TOMATO BISQUE",
        price: "$15.95",
        description: "Crispy, buttery grilled cheese served with a rich, velvety tomato bisque — the ultimate comfort combo.",
        image: placeholderImage
      },
      {
        name: "THE ITALIAN",
        price: "$15.95",
        description: "Savor home-sliced prosciutto with fresh mozzarella, vine-ripened tomatoes, basil, a drizzle of olive oil, balsamic glaze, and a hint of homemade pesto.",
        image: theItalianImage
      }
    ],
    "houseDishes": [
      {
        name: "CRISPY BUFFALO CHICKEN WRAP",
        price: "$17.00",
        description: "Crispy chicken tossed in tangy buffalo sauce, tomato, cheese, bacon, lettuce, red onion, and Caesar dressing wrapped in a fresh flour tortilla.",
        image: crispyBuffaloChickenWrapImage
      },
      {
        name: "CHEESE PLATE",
        price: "$19.95",
        description: "A medley of cubed and sliced cheeses, paired with dips, crackers, savory pickled veggies, and fresh-cut fruits.",
        image: placeholderImage
      },
      {
        name: "BAKED PASTA",
        price: "",
        description: "Penne pasta coated in your choice of sauce, topped with melted mozzarella cheese and baked to perfection. Customize with added protein and veggies!",
        image: bakedPastaImage
      },
      {
        name: "NACHO FRIES",
        price: "$11.95",
        description: "Golden Yukon crispy fries crowned with cheese sauce, pico de gallo, sour cream, and green salsa. Add your favorite protein for an extra twist!",
        image: nachoFriesImage
      },
      {
        name: "FRIED RICE",
        price: "$11.95",
        description: "A savory mix of tender rice, sautéed vegetables, and scrambled egg, all tossed in a rich soy sauce and topped with green onions. Perfect as a side or add your favorite protein for a complete meal.",
        image: friedRiceImage
      }
    ],
    "salads": [
      {
        name: "THE WEDGE SALAD",
        price: "$11.95",
        description: "A crisp iceberg wedge topped with creamy blue cheese dressing, cherry tomatoes, bacon crumbles, and red onion. Cool, crunchy, and classic.",
        image: placeholderImage
      },
      {
        name: "MIXED SALAD",
        price: "$13.95",
        description: "A vibrant blend of greens, cherry tomatoes, cucumbers, red onions, and shredded carrots — served with your choice of dressing.",
        image: placeholderImage
      },
      {
        name: "CAPRESE SALAD",
        price: "$13.95",
        description: "Fresh mozzarella, ripe tomatoes, and basil drizzled with balsamic glaze and extra virgin olive oil. A light, classic Italian favorite.",
        image: placeholderImage
      },
      {
        name: "CAESAR SALAD",
        price: "$13.95",
        description: "Crisp romaine tossed in creamy Caesar dressing with parmesan, crunchy croutons, and a squeeze of fresh lemon.",
        image: placeholderImage
      }
    ],
    "kids": [
      {
        name: "KIDS CHEESEBURGER AND FRIES",
        price: "$11.95",
        description: "Kid-sized cheeseburger with golden fries — perfect for our little diners.",
        image: placeholderImage
      },
      {
        name: "KIDS HAMBURGER AND FRIES",
        price: "$11.95",
        description: "Classic hamburger with crispy fries — sized just right for kids.",
        image: placeholderImage
      },
      {
        name: "KIDS PASTA",
        price: "$11.95",
        description: "Tender pasta with your choice of butter or marinara sauce — a kid favorite.",
        image: placeholderImage
      },
      {
        name: "KIDS TENDERS N FRIES",
        price: "$11.95",
        description: "Crispy chicken tenders with golden fries — kid-approved and delicious.",
        image: placeholderImage
      },
      {
        name: "KIDS CLASSIC BREAKFAST",
        price: "$11.95",
        description: "Eggs, bacon, and toast — a perfect start to any kid's day.",
        image: placeholderImage
      },
      {
        name: "KIDS LOADED MAC N CHEESE",
        price: "$11.95",
        description: "Creamy mac and cheese loaded with kid-friendly toppings.",
        image: placeholderImage
      }
    ],
    "desserts": [
      {
        name: "VANILLA ICE CREAM",
        price: "$4.95",
        description: "Classic vanilla ice cream — simple and delicious.",
        image: placeholderImage
      },
      {
        name: "CHEESECAKE",
        price: "$9.00",
        description: "Homemade cheesecake — rich, creamy, and absolutely divine.",
        image: placeholderImage
      },
      {
        name: "AFFOGATO",
        price: "$9.00",
        description: "Vanilla ice cream 'drowned' in a shot of hot espresso — the perfect Italian dessert.",
        image: placeholderImage
      },
      {
        name: "TIRAMISU",
        price: "$9.00",
        description: "Classic Italian dessert with layers of coffee-soaked ladyfingers and mascarpone cream.",
        image: placeholderImage
      }
    ],
    "breakfast": [
      {
        name: "DAN GRUBS BENEDICT",
        price: "$20.95",
        description: "Crispy chicken topped with melting gouda cheese, crispy bacon, poached egg, and homemade hollandaise sauce, served with either country potato or hash browns.",
        image: placeholderImage
      },
      {
        name: "CHICKEN AND WAFFLES",
        price: "",
        description: "Crispy fried chicken served atop golden Belgian waffles — a perfect sweet and savory combination.",
        image: placeholderImage
      },
      {
        name: "FRESH FRUIT BOWL",
        price: "$6.00",
        description: "A colorful mix of seasonal fresh fruits — nature's perfect start to your day.",
        image: placeholderImage
      },
      {
        name: "BREAKFAST SANDWICH",
        price: "$17.95",
        description: "Hearty breakfast sandwich with eggs, cheese, and your choice of meat on toasted bread.",
        image: placeholderImage
      },
      {
        name: "BISCUITS & GRAVY",
        price: "$17.95",
        description: "Fluffy buttermilk biscuits smothered in rich, creamy sausage gravy — comfort food at its finest.",
        image: placeholderImage
      },
      {
        name: "CHILAQUILES",
        price: "$11.95",
        description: "Crispy tortilla chips drenched in red salsa, topped with pico de gallo, sour cream, queso fresco, and your choice of eggs.",
        image: placeholderImage
      },
      {
        name: "SHORT STACK PANCAKES",
        price: "$10.95",
        description: "Three fluffy pancakes served with butter and maple syrup — a breakfast classic.",
        image: placeholderImage
      },
      {
        name: "MAPLE BACON PANCAKES",
        price: "$14.95",
        description: "Fluffy pancakes studded with crispy bacon pieces and drizzled with maple syrup.",
        image: placeholderImage
      },
      {
        name: "BELGIAN WAFFLES",
        price: "$10.95",
        description: "Golden, crispy Belgian waffles served with butter and syrup — light and airy perfection.",
        image: placeholderImage
      },
      {
        name: "CLASSIC FRENCH TOAST",
        price: "$12.95",
        description: "Thick-cut brioche dipped in vanilla custard and grilled to golden perfection.",
        image: placeholderImage
      },
      {
        name: "BANANA PECAN TOAST",
        price: "$16.95",
        description: "French toast topped with fresh bananas and crunchy pecans — a delightful morning treat.",
        image: placeholderImage
      },
      {
        name: "NUTELLA FRENCH TOAST",
        price: "$16.95",
        description: "Decadent French toast filled with creamy Nutella — pure indulgence on a plate.",
        image: placeholderImage
      },
      {
        name: "CLASSIC BREAKFAST",
        price: "$17.95",
        description: "Two eggs your way, choice of bacon or sausage, hash browns, and toast — the ultimate breakfast combo.",
        image: placeholderImage
      },
      {
        name: "BREAKFAST BURRITO",
        price: "$17.95",
        description: "Scrambled eggs, cheese, hash browns, and your choice of meat wrapped in a warm flour tortilla.",
        image: placeholderImage
      },
      {
        name: "TWO EGGS ANY STYLE",
        price: "$6.00",
        description: "Two fresh eggs prepared exactly how you like them.",
        image: placeholderImage
      },
      {
        name: "HOLLANDAISE SAUCE",
        price: "$6.00",
        description: "Rich, buttery hollandaise sauce — perfect for elevating any dish.",
        image: placeholderImage
      },
      {
        name: "PORK SAUSAGE",
        price: "$8.00",
        description: "Savory pork sausage links — perfectly seasoned and grilled.",
        image: placeholderImage
      },
      {
        name: "CRISPY BACON",
        price: "$8.00",
        description: "Thick-cut bacon cooked to crispy perfection.",
        image: placeholderImage
      },
      {
        name: "BUTTERED TOAST",
        price: "$6.00",
        description: "Choice of bread toasted golden and buttered — simple perfection.",
        image: placeholderImage
      },
      {
        name: "EGG WHITES",
        price: "$6.00",
        description: "Light and fluffy egg whites — a healthier breakfast option.",
        image: placeholderImage
      },
      {
        name: "SAUSAGE GRAVY",
        price: "$6.00",
        description: "Rich, creamy sausage gravy — perfect for biscuits or hash browns.",
        image: placeholderImage
      },
      {
        name: "CHICKEN APPLE SAUSAGE",
        price: "$8.00",
        description: "Lean chicken sausage with sweet apple — a lighter, flavorful option.",
        image: placeholderImage
      },
      {
        name: "CANADIAN BACON",
        price: "$8.00",
        description: "Lean, savory Canadian bacon — grilled to perfection.",
        image: placeholderImage
      },
      {
        name: "TURKEY BACON",
        price: "$8.00",
        description: "Crispy turkey bacon — a leaner alternative with great flavor.",
        image: placeholderImage
      },
      {
        name: "CHORIZO",
        price: "$8.00",
        description: "Spicy Mexican chorizo — packed with flavor and heat.",
        image: placeholderImage
      }
    ],
    "drinks": [
      {
        name: "HORCHATA",
        price: "$8.00",
        description: "Traditional Mexican rice drink with cinnamon and vanilla — creamy and refreshing.",
        image: placeholderImage
      },
      {
        name: "BOTTLED BEVERAGES",
        price: "$7.00",
        description: "Selection of premium bottled drinks — ask your server for today's options.",
        image: placeholderImage
      },
      {
        name: "FRESH JUICES",
        price: "$5.00",
        description: "Freshly squeezed juices — orange, apple, cranberry, and more.",
        image: placeholderImage
      },
      {
        name: "ENERGIZERS",
        price: "$8.95",
        description: "Energy drinks and enhanced beverages to fuel your day.",
        image: placeholderImage
      },
      {
        name: "FOUNTAIN SODA",
        price: "$4.00",
        description: "Classic fountain sodas — Coke, Pepsi, Sprite, and more.",
        image: placeholderImage
      },
      {
        name: "FRESH BREWED COFFEE",
        price: "$5.95",
        description: "Rich, aromatic coffee brewed fresh throughout the day.",
        image: placeholderImage
      }
    ],
    "specials": [
      {
        name: "NASHVILLE HOT CHICKEN SANDWICH",
        price: "$15.95",
        description: "Fiery Nashville-style hot chicken with cooling pickles and creamy slaw on a brioche bun.",
        image: placeholderImage
      },
      {
        name: "DOG PATTY",
        price: "$5.95",
        description: "Specialty patty for our four-legged friends — made with dog-safe ingredients.",
        image: placeholderImage
      },
      {
        name: "CHEESY JALAPEÑO BREAD",
        price: "$13.95",
        description: "Warm bread stuffed with melted cheese and spicy jalapeños — perfect for sharing.",
        image: placeholderImage
      },
      {
        name: "MAC N CHEESE BALLS",
        price: "$13.95",
        description: "Creamy mac and cheese formed into golden, crispy balls — comfort food reimagined.",
        image: placeholderImage
      },
      {
        name: "CHEESY GARLIC BREAD",
        price: "$11.95",
        description: "Toasted bread loaded with garlic butter and melted cheese — irresistibly delicious.",
        image: placeholderImage
      },
      {
        name: "FISH N CHIPS",
        price: "$19.00",
        description: "Beer-battered fish with golden fries and tartar sauce — a classic pub favorite.",
        image: placeholderImage
      },
      {
        name: "BIRRIA HOT CHEETO BALLS",
        price: "$13.95",
        description: "Crispy balls filled with tender birria and coated in Hot Cheeto dust — a fusion sensation.",
        image: placeholderImage
      }
    ]
  };

  const sauceInfo = {
    title: "Make it saucy!",
    description: "Toss your wings and chicken tenders in any of our signature sauces for an extra flavor boost (add-on):",
    sauces: [
      "Buffalo – Classic heat with a tangy kick",
      "BBQ – Sweet, smoky, and crowd-pleasing",
      "Mango Habanero (🔥 Spicy) – Sweet, smoky, and crowd-pleasing",
      "Lemon Pepper – Bright, citrusy, and seasoned to perfection",
      "Sweet Chili – A balanced blend of sweet and mild heat",
      "Honey Bourbon (contains honey) – Smooth, sweet, and kissed with bourbon warmth"
    ]
  };

  const categoryDisplayNames = {
    appetizers: "Appetizers",
    sides: "Side Dishes",
    sandwiches: "In the Buns",
    houseDishes: "House Dishes",
    salads: "Salads",
    kids: "Kids Menu",
    desserts: "Desserts",
    breakfast: "Breakfast",
    drinks: "Drinks",
    specials: "Specials"
  };

  const tabs = [
    { key: 'appetizers', label: 'Appetizers', mobileLabel: 'Apps' },
    { key: 'sides', label: 'Side Dishes', mobileLabel: 'Sides' },
    { key: 'sandwiches', label: 'In the Buns', mobileLabel: 'Burgers' },
    { key: 'houseDishes', label: 'House Dishes', mobileLabel: 'House' },
    { key: 'salads', label: 'Salads', mobileLabel: 'Salads' },
    { key: 'kids', label: 'Kids Menu', mobileLabel: 'Kids' },
    { key: 'desserts', label: 'Desserts', mobileLabel: 'Desserts' },
    { key: 'breakfast', label: 'Breakfast', mobileLabel: 'Breakfast' },
    { key: 'drinks', label: 'Drinks', mobileLabel: 'Drinks' },
    { key: 'specials', label: 'Specials', mobileLabel: 'Specials' }
  ];

  return (
    <>
      <Hero title="Food" height="40vh" useClipPath={true} image={placeholderFoodImage} />

      {/* Sticky Tab Navigation */}
      <div className="tab-navigation">
        <div className="tab-container">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              <span className="tab-label-desktop">{tab.label}</span>
              <span className="tab-label-mobile">{tab.mobileLabel}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="menu-page">
        {/* Display only the active section */}
        {Object.entries(menuData)
          .filter(([categoryKey]) => categoryKey === activeTab)
          .map(([categoryKey, items]) => (
            <section key={categoryKey} className="menu-category">
              <div className="category-header">
                <h2>{categoryDisplayNames[categoryKey as keyof typeof categoryDisplayNames]}</h2>
              </div>
              <div className="menu-items-grid">
                {items.map((item, itemIndex) => (
                  <div key={itemIndex} className="menu-item-card">
                    <div className="menu-item-image-container" onClick={() => openModal(item.image, item.name)}>
                      <img src={item.image} alt={item.name} className="menu-item-image" />
                    </div>
                    <div className="menu-item-content">
                      <div className="menu-item-info">
                        <div className="menu-item-header">
                          <h3 className="menu-item-name">{item.name}</h3>
                          {item.price && <span className="menu-item-price">{item.price}</span>}
                        </div>
                        {item.description && (
                          <p className="menu-item-description">{item.description}</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {categoryKey === 'appetizers' && (
                <div className="sauce-info" style={{ marginTop: '2rem', padding: '1.5rem', backgroundColor: '#f8f8f8', borderRadius: '8px' }}>
                  <h3 style={{ marginBottom: '1rem', color: '#3D3D3D' }}>{sauceInfo.title}</h3>
                  <p style={{ marginBottom: '1rem', color: '#666' }}>{sauceInfo.description}</p>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {sauceInfo.sauces.map((sauce, index) => (
                      <li key={index} style={{ marginBottom: '0.5rem', color: '#666' }}>• {sauce}</li>
                    ))}
                  </ul>
                </div>
              )}
            </section>
          ))}
      </div>

      {/* Modal */}
      {modalImage && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <img src={modalImage} alt={modalAlt} className="modal-image" />
            <p className="modal-caption">{modalAlt}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default FoodMenu; 